import { Col, Row } from 'react-bootstrap';
import { getCurrentUser } from '../../../services/helper';
import { LessonPlan, Recipe } from '../../../types/lessonPlan.type';
import './RecipeStats.css';

interface RecipeStatsType {
  recipe?: Recipe;
  lessonPlan?: LessonPlan | null;
}

const RecipeStats: React.FC<RecipeStatsType> = ({ recipe, lessonPlan }) => {
  const currentUser = getCurrentUser();
  let prepTime = 0;
  let cookTime = 0;
  let minServed = 0;
  let maxServed = 0;
  if (lessonPlan && currentUser?.hasDashAccess) {
    prepTime = lessonPlan.lesson_prep_time ?? 0;
    cookTime = lessonPlan.lesson_cook_time ?? 0;
    minServed = lessonPlan.lesson_min_served ?? 0;
    maxServed = lessonPlan.lesson_max_served ?? 0;
  } else {
    prepTime = recipe?.prep_time ?? lessonPlan?.prep_time ?? 0;
    cookTime = recipe?.cook_time ?? lessonPlan?.cook_time ?? 0;
    minServed = recipe?.min_served ?? lessonPlan?.min_served ?? 0;
    maxServed = recipe?.max_served ?? lessonPlan?.max_served ?? 0;
  }

  return (
    <>
      <div>
        <div className="recipe-features">
          <Row className="columns-recipe-features">
            <Col
              lg={4}
              className="column-recipe-features"
            >
              <div className="div-recipe-features-copy">
                <div className="subheader fw-bold mb-0">prep time</div>
                <div>{prepTime} minutes</div>
              </div>
            </Col>
            <Col
              lg={4}
              className="column-recipe-features"
            >
              <div className="div-recipe-features-copy">
                <div className="subheader fw-bold mb-0">cook time</div>
                <div>{cookTime} minutes</div>
              </div>
            </Col>
            <Col lg={4}>
              <div className="div-recipe-features-copy">
                <div className="subheader fw-bold mb-0">makes</div>
                <div>
                  {minServed} - {maxServed} servings
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="dots recipe"></div>
    </>
  );
};

export default RecipeStats;
